import React from 'react';

import AnimalTypeSwitcherRadioButton from './AnimalTypeSwitcherRadioButton';
import AnimalTypeResourceType from './../../types/AnimalTypeResourceType';

/**
 * Animal Switcher component
 */
const AnimalTypeSwitcher = (props) => {
  const {label, data} = props.data;
  const {selected, clicked} = props;
  return (
    <div className="nppe2-fc-animal-type-switcher">
      <h2>{label}</h2>
      <hr/>
      <div className="row">
        {data.map((value, index) => (
          <AnimalTypeSwitcherRadioButton
              key={index}
              index={index}
              data={value}
              selected={selected}
              clicked={clicked}
          />
        ))}
      </div>
    </div>
  );
};

AnimalTypeSwitcher.propTypes = AnimalTypeResourceType;

export default AnimalTypeSwitcher;
